import React from "react";
import addCircleIcon from "../../assets/images/icons/ads-add-circle.svg";
import minusCircleIcon from "../../assets/images/icons/ads-minus-circle.svg";
import dateIcon from "../../assets/images/icons/ads-date-icon.svg";

export default function PromoteBudget({ formData, updateFormData, onNext }) {
  const days =
    formData.startDate && formData.endDate
      ? Math.max(
          1,
          Math.ceil((new Date(formData.endDate) - new Date(formData.startDate)) / (1000 * 60 * 60 * 24))
        )
      : null;

  const canContinue = Number(formData.budget) >= 10 && formData.startDate && formData.endDate;

  return (
    <div>
      <label className="block text-sm font-semibold text-black mb-2">Budget type</label>
      <div className="flex gap-3 mb-6">
        {[
          { value: "daily", label: "Daily Budget" },
          { value: "lifetime", label: "Lifetime Budget" },
        ].map((opt) => (
          <button
            key={opt.value}
            type="button"
            onClick={() => updateFormData({ budgetType: opt.value })}
            className={`px-5 py-2 rounded-full text-sm font-semibold ${
              formData.budgetType === opt.value
                ? "bg-[#095228] text-white"
                : "border border-[#c3c5d9] text-[#434656]"
            }`}
          >
            {opt.label}
          </button>
        ))}
      </div>

      <label className="block text-sm font-semibold text-black mb-2">Budget</label>
      <div className="flex items-center gap-3 mb-2">
        <button
          type="button"
          onClick={() => updateFormData({ budget: Math.max(0, Number(formData.budget || 0) - 10) })}
          className="w-10 h-10 rounded-full bg-[#095228] flex items-center justify-center shrink-0"
        >
          <img src={minusCircleIcon} alt="Decrease" className="w-full h-full" />
        </button>
        <div className="flex-1 border border-[#c3c5d9] rounded-xl px-4 py-3 flex items-center gap-2">
          <span>$</span>
          <input
            type="number"
            value={formData.budget}
            onChange={(e) => updateFormData({ budget: e.target.value })}
            className="w-full outline-none"
          />
        </div>
        <button
          type="button"
          onClick={() => updateFormData({ budget: Number(formData.budget || 0) + 10 })}
          className="w-10 h-10 rounded-full bg-[#095228] flex items-center justify-center shrink-0"
        >
          <img src={addCircleIcon} alt="Increase" className="w-full h-full" />
        </button>
      </div>
      <p className="text-xs text-[#747474] mb-6">
        Minimum $ 10 /day. You can pause or edit spend anytime.
      </p>

      <div className="flex items-center justify-between mb-2">
        <label className="text-sm font-semibold text-black">Schedule</label>
        {days && <span className="text-sm text-[#095228] font-semibold">{days} Days</span>}
      </div>
      <div className="flex gap-3 mb-10">
        <div className="relative flex-1">
          <img src={dateIcon} alt="" className="absolute left-4 top-1/2 -translate-y-1/2 w-[22px] h-[22px] pointer-events-none" />
          <input
            type="date"
            value={formData.startDate}
            onChange={(e) => updateFormData({ startDate: e.target.value })}
            className="w-full border border-[#c3c5d9] rounded-full pl-12 pr-4 py-3"
          />
        </div>
        <div className="relative flex-1">
          <img src={dateIcon} alt="" className="absolute left-4 top-1/2 -translate-y-1/2 w-[22px] h-[22px] pointer-events-none" />
          <input
            type="date"
            value={formData.endDate}
            min={formData.startDate || undefined}
            onChange={(e) => updateFormData({ endDate: e.target.value })}
            className="w-full border border-[#c3c5d9] rounded-full pl-12 pr-4 py-3"
          />
        </div>
      </div>

      <button
        type="button"
        disabled={!canContinue}
        onClick={onNext}
        className="bg-[#095228] border border-[#39b54a] text-[#f9e9ea] font-medium text-lg px-10 py-3 rounded-full shadow-[0_0_6px_rgba(59,182,76,0.53)] disabled:opacity-50"
      >
        Continue
      </button>
    </div>
  );
}
